export default "__VITE_ASSET__BzBFeWk1__";